module.exports = __webpack_public_path__ + "media/won.9c1c3870.mp3";